import {
  DEVICE_SWAPS_PER_MONTH,
  deviceSwapExhaustedCopy
} from "@recital-master/shared";

export function deviceSwapBalanceCopy(
  swapsRemaining: number | null,
  nextSwapAvailableAt: string | null = null
): string {
  const remaining = swapsRemaining ?? DEVICE_SWAPS_PER_MONTH;
  // The zero state borrows the swap panel's exact line so the two surfaces
  // never disagree about when the quota comes back.
  if (remaining <= 0) return deviceSwapExhaustedCopy(nextSwapAvailableAt);
  return `${remaining} of ${DEVICE_SWAPS_PER_MONTH} swaps left this month`;
}
